import { gql } from '@apollo/client'

export const SERIES_SQUAD_FORMAT = gql`
  query GetSeriesByIdFront($input: oGetSeriesByIdFrontInput!) {
    getSeriesByIdFront(input: $input) {
      sFormats
    }
  }
`
export const FORMAT_WISE_PLAYERS = gql`
  query ListSeriesSquadInFormat($input: listSeriesSquadInputFormatArr) {
    listSeriesSquadInFormat(input: $input) {
      all {
        oPlayer {
          eTagStatus
          oSeo {
            sSlug
            eType
          }
          oImg {
            sUrl
          }
          sFullName
          sFirstName
          sPlayingRole
        }
      }
    }
  }
`
